import type { DeepString } from "@/lib/i18n";

/**
 * CBrowserPressOnline - polskie tlumaczenia (Przegladarka prasy online -
 * lista wydan + widok wydania ze stronami klikalnymi do lightboxa).
 *
 * `pagesCount(n)` - polska odmiana rzeczownika "strona" przez liczebnik:
 *   1 -> "strona", 2-4 (oprocz 12-14) -> "strony", reszta -> "stron".
 */
export const pl = {
  emptyData: "Brak danych do wyświetlenia.",
  emptyList: "Brak wydań do wyświetlenia.",
  emptyIssue: "To wydanie nie zawiera jeszcze stron.",
  backToList: "<- Wróć do listy wydań",
  openPage: "Otwórz stronę",
  download: "Pobierz",
  offer: "Zobacz całą ofertę",
  newsletter: "Zamów newsletter",
  applies: "Obowiązuje",
  from: "od",
  to: "do",
  /** `pagesCount(5)` -> "5 stron". */
  pagesCount: (n: number): string => {
    const abs = Math.abs(n);
    const last = abs % 10;
    const lastTwo = abs % 100;
    let word: string;
    if (abs === 1) word = "strona";
    else if (last >= 2 && last <= 4 && !(lastTwo >= 12 && lastTwo <= 14))
      word = "strony";
    else word = "stron";
    return `${n} ${word}`;
  },
  /** `pageLabel(3)` -> "Strona 3". */
  pageLabel: (n: number) => `Strona ${n}`,
  /** Format daty dla dat obowiazywania (YYYY-MM-DD -> DD.MM.YYYY). */
  formatDate: (iso: string): string => {
    const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return iso;
    return `${m[3]}.${m[2]}.${m[1]}`;
  },
} as const;

export type CBrowserPressOnlineTranslations = DeepString<typeof pl>;
